module.exports = __webpack_public_path__ + "files/18b99fe42142cb6cf864158a98737a27.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/symbols-6.png
// module id = 1392
// module chunks = 59